import { render, staticRenderFns } from "./AudienceDialog.vue?vue&type=template&id=866d0480"
import script from "./AudienceDialog.vue?vue&type=script&lang=js"
export * from "./AudienceDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports